import { MESSAGE_TYPE, NativeAdTemplate, PLUGIN_ID_PREFIX } from 'emma-common-ts/emma';

export const helpTitlePushMessage = $localize`Si utilizas etiquetas en el mensaje Push, recuerda que el número de caracteres que se utilicen puede variar y exceder los 50 del límite para el título.`;
export const helpTextPushMessage = $localize`Si utilizas etiquetas en el mensaje Push, recuerda que el número de caracteres que se utilicen puede variar y exceder los 144 del límite para el mensaje.`;
export const helpTextCommonField: string = $localize`Este campo es común para todos los idiomas y solo puede editarse en el idioma por defecto de la versión seleccionada.`;

export const messageTypeName = ({
  messageType,
  nativeAdTemplates,
  templateId,
}: {
  messageType: MESSAGE_TYPE;
  nativeAdTemplates: Array<NativeAdTemplate>;
  templateId?: string;
}): string => {
  if (templateId?.startsWith(PLUGIN_ID_PREFIX)) {
    const template = nativeAdTemplates.find((t) => t.templateId === templateId);
    return template?.name || $localize`Plugin`;
  } else {
    return translateMessageType(messageType);
  }
};

export const translateMessageType = (messageType: MESSAGE_TYPE): string => {
  switch (messageType) {
    case MESSAGE_TYPE.ADBALL:
      return $localize`AdBall`;
    case MESSAGE_TYPE.BANNER:
      return $localize`Banner`;
    case MESSAGE_TYPE.COUPON:
      return $localize`Cupón`;
    case MESSAGE_TYPE.DYNAMICTAB:
      return $localize`Tab Dinámico`;
    case MESSAGE_TYPE.EMAIL:
      return $localize`Email`;
    case MESSAGE_TYPE.NATIVEAD:
      return $localize`Native Ad`;
    case MESSAGE_TYPE.STARTVIEW:
      return $localize`StartView`;
    case MESSAGE_TYPE.PUSH:
      return $localize`Push`;
    case MESSAGE_TYPE.STRIP:
      return $localize`Strip`;
    default:
      return '';
  }
};
